import { usePunditUserContext } from "@circle-react/contexts";

export const useContactsSearchEnabledForMembersAndSpaces = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(
    currentCommunitySettings?.contacts_search_enabled_for_members_and_spaces,
  );
};
